export default __webpack_public_path__ + "static/media/hearth.c638b404.svg";